import {SET_USER_PROFILE} from "../actions/actions";

const UserProfile=(state:any= {}, action:any)=>{
    switch (action.type) {
        case SET_USER_PROFILE:
            return action.payload;
        default:
            return state
    }
}
export default UserProfile;